"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _libphonenumberJs = require("libphonenumber-js"),
    _classnames = _interopRequireDefault(require("classnames")),
    _Input = _interopRequireDefault(require("../../Input")),
    _Dropdown = _interopRequireDefault(require("../../Dropdown")),
    _countries = _interopRequireDefault(require("../constants/countries.json")),
    _phoneNumberInput = require("../styles/phoneNumberInput"),
    _blank = _interopRequireDefault(require("../../../../assets/blank.gif")),
    _flags = _interopRequireDefault(require("../../../../assets/flags.png")),
    _flags2 = require("../styles/flags");

require("../styles/_phone-number-input.scss");

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var HEIGHT = "calc(100% - 2px)",
    getCountryCodeFromKey = function getCountryCodeFromKey(a) {
  return a.split("_")[0];
},
    overrideDropDownStyles = {
  menu: {
    position: "fixed",
    width: "100%"
  },
  valueContainer: {
    marginTop: "auto"
  },
  control: {
    border: "none",
    margin: "1px",
    height: "calc(100% - 2px)",
    minHeight: "calc(100% - 2px)"
  }
};

function findInitialCountry(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : "AU";
  return a.find(function (a) {
    return getCountryCodeFromKey(a.value) === b;
  }) || a[0];
}

function generateCountryOptions() {
  return _countries["default"].map(function (a) {
    return {
      label: a.name,
      value: "".concat(a.countryCode, "_").concat(a.name),
      prefix: _react["default"].createElement("img", {
        alt: a.countryCode,
        className: (0, _classnames["default"])((0, _flags2.FLAG)(_flags["default"]), (0, _flags2.SINGLE_FLAG)(a.countryCode)),
        src: _blank["default"]
      }),
      suffix: a.dialCode
    };
  });
}

function attemptToParseNumber(a, b) {
  var c = {
    number: a,
    valid: !1
  };
  if (!a || 1 === a.length) return c;

  try {
    var d = (0, _libphonenumberJs.parsePhoneNumber)(a, b);
    return d ? {
      country: d.country,
      number: d.number,
      nationalNumber: d.nationalNumber,
      valid: d.isValid()
    } : c;
  } catch (a) {
    return c;
  }
}

var PhoneNumberInput = function (a) {
  function b(a) {
    var d;
    (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), _initialiseProps.call((0, _assertThisInitialized2["default"])(d));
    var e = generateCountryOptions(),
        f = attemptToParseNumber(a.initialNumber),
        g = f.country,
        h = f.nationalNumber,
        i = f.number,
        j = findInitialCountry(e, g);
    return d.state = {
      countries: e,
      selectedCountry: j,
      number: h ? "0".concat(h) : i,
      valid: !0
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "handleOnChange",
    value: function handleOnChange() {
      var a = this.state,
          b = a.number,
          c = a.selectedCountry,
          d = this.props.onChange,
          e = getCountryCodeFromKey(c.value),
          f = attemptToParseNumber(b, e),
          g = f.number,
          h = f.valid;
      this.setState({
        valid: h
      }, this.handleValidate), d(g);
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.id,
          c = a.errorMessage,
          d = a.placeholder,
          e = a.label,
          f = this.state,
          g = f.countries,
          h = f.number,
          i = f.selectedCountry;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_phoneNumberInput.PHONE_NUMBER_INPUT, "phone-number-input")
      }, _react["default"].createElement(_Input["default"], {
        className: "phone-number-input__input",
        type: "number",
        id: b,
        defaultValue: h,
        onChange: this.updateNumber,
        validate: this.handleValidate,
        errorMessage: c,
        placeholder: d,
        label: e,
        styleType: "PRIMARY",
        prefix: _react["default"].createElement("span", {
          role: "listbox",
          tabIndex: 0,
          onClick: function onClick(a) {
            return a.stopPropagation();
          },
          onKeyDown: function onKeyDown(a) {
            return a.stopPropagation();
          },
          className: "phone-number-input__drop-down__wrapper"
        }, _react["default"].createElement(_Dropdown["default"], {
          prefix: "phone-number-input",
          className: "phone-number-input__drop-down",
          hideSelectedLabel: !0,
          id: "".concat(b, "-countries"),
          options: g,
          defaultValue: i,
          onChange: this.handleCountryChange,
          upperCaseLabels: !0,
          overrideDropDownStyles: overrideDropDownStyles,
          renderMenuLocally: !0
        }))
      }));
    }
  }]), b;
}(_react.Component);

exports["default"] = PhoneNumberInput, PhoneNumberInput.defaultProps = {
  initialNumber: ""
};

var _initialiseProps = function _initialiseProps() {
  var a = this;
  this.handleValidate = function () {
    var b = a.state,
        c = b.valid,
        d = b.number,
        e = a.props,
        f = e.onValidate,
        g = e.emptyIsValid;
    return !(!g || d) || (f && f(c), c);
  }, this.updateNumber = function (b) {
    var c = b.target.value;
    a.setState({
      number: c
    }, a.handleOnChange);
  }, this.handleCountryChange = function (b) {
    a.setState({
      selectedCountry: b
    }, a.handleOnChange);
  };
};